import { useEffect, useRef } from "react";
import { Card, CardBody, Col } from "reactstrap";
import Sortable from "sortablejs";
import { Image } from "../../../AbstractElements";
import { RandomSortable } from "../../../Constants/Constants";
import { RandomSortableData } from "../../../Data/BonusUi/Tree";
import { dynamicImage, dynamicNumber } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const RandomSortableGrid = () => {
  const gridRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (gridRef.current) {
      Sortable.create(gridRef.current, {
        animation: 150,
      });
    }
  }, []);

  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={RandomSortable} span={RandomSortableData} />
        <CardBody>
          <div className="grid-box-wrapper" id="sortable-grids" ref={gridRef}>
            {dynamicNumber(12).map((_, index) => (
              <div className="grid-box" key={index}>
                <Image src={dynamicImage(`social-app/post-${(index % 9) + 1}.png`)} alt={`Post ${index + 1}`} />
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RandomSortableGrid;
